export default __webpack_public_path__ + "static/icon_black-3e4f4e649a68868365a8774267c8006b.png";